import { Component, OnInit, ViewEncapsulation, NgZone, OnDestroy } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Router } from '@angular/router';
import { TranslatorService } from '../../../core/translator/translator.service';
import { Subscription } from 'rxjs';
import { MeteorUser } from '../../../../../../backend/server/data-models/meteor-user/meteor-user';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {

    valForm: FormGroup;
    selectedLanguage: string;

    langs: Promise<{ code: string, text: string }[]>;
    langsSubscription: Subscription;

    constructor(
        public settings: SettingsService,
        public fb: FormBuilder,
        public ngZone: NgZone,
        public router: Router,
        public translator: TranslatorService
    ) {
        Meteor.logout();

        this.valForm = fb.group({
            'email': [null, [Validators.required, CustomValidators.email]],
            'password': [null, [Validators.required]]
        });

        this.langsSubscription = this.translator.availableLangs.subscribe(langs => {
            // console.warn("LOGIN LANGS"); console.warn(langs);
            this.langs = Promise.resolve(langs);
        });
        this.selectedLanguage = this.translator.useLanguage();
    }

    submitForm() {
        this.valForm.updateValueAndValidity();

        for (let c in this.valForm.controls) {
            this.valForm.controls[c].markAsTouched();
        }

        if (this.valForm.valid) {
            this.login(this.valForm.controls['email'].value, this.valForm.controls['password'].value);
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.langsSubscription) this.langsSubscription.unsubscribe();
    }

    login(email: string, password: string) {
        Meteor.loginWithPassword(email, password, (err) => {
            this.ngZone.run(
                () => {
                    if (err) {
                        console.warn("Login failed! " + err);
                        this.valForm.controls['password'].setErrors({ "loginError": err.toString });
                    } else {
                        const user: MeteorUser = new MeteorUser(Meteor.user());
                        console.warn("Login success!"); console.warn(user);
                        if (!user || !user.emails || user.emails.length === 0) {
                            console.warn("User ha no email!");
                            this.router.navigate(['/login']);
                        } else {
                            if (user.emails.filter(e => e.verified !== true).length !== 0) {
                                console.warn("User not activated!");
                                this.router.navigate(["/verify-email"]);
                            } else {

                                this.settings.setUserSetting("lang", this.selectedLanguage);
                                this.router.navigate(['']);
                            }
                        }
                    }
                }
            );
        });
    }

    setLang(value) {
        this.selectedLanguage = value
        this.settings.setUserSetting("lang", value);
        this.translator.useLanguage(value);
    }
}
